// Sizing budgets shared by every search preview variant.
//
// 1.6:1 slide aspect, base 1280×800. Native rendering uses transform: scale,
// so wrappers must set an explicit pixel height to prevent the 800px native
// box from forcing the dropdown row taller.
//
// 380 was the previous single-slide width; dropping ~15% to 324 lets two
// 150px tiles fit horizontally inside the ~360px inner pane.

export const PANE_MAX_WIDTH = 380
export const PANE_MIN_WIDTH = 300
export const PANE_PADDING = 16
export const PANE_MIN_HEIGHT = 160
export const PANE_MAX_HEIGHT_VH = 50

export const PREVIEW_SLIDE_WIDTH = 324
export const PREVIEW_SLIDE_HEIGHT = Math.round(PREVIEW_SLIDE_WIDTH / 1.6)

// Tiled grid — 2 columns inside the pane.
export const TILE_GAP = 8
export const TILE_WIDTH = 150
export const TILE_HEIGHT = Math.round(TILE_WIDTH / 1.6)
